import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './HighlighterWithRichtextHOC.css';
import React from 'react';
var highlightText = function highlightText(text, searchWords) {
  if (!searchWords.length) return text;
  var searchWordsArr = searchWords.split(" ");
  var regex = new RegExp("(".concat(searchWordsArr.join('|'), ")"), 'gi');
  var parts = text.split(regex);
  return parts.map(function (part, index) {
    return regex.test(part) ? /*#__PURE__*/React.createElement("span", {
      key: index,
      className: "marked"
    }, part) : part;
  });
};
var transformInlineStyles = function transformInlineStyles(cssString) {
  var stylesArray = cssString.split(';').filter(Boolean);
  var stylesObject = {};
  stylesArray.forEach(function (style) {
    var _style$split$map = style.split(':').map(function (item) {
        return item.trim();
      }),
      _style$split$map2 = _slicedToArray(_style$split$map, 2),
      property = _style$split$map2[0],
      value = _style$split$map2[1];
    var camelCaseProperty = property.replace(/-([a-z])/g, function (match, letter) {
      return letter.toUpperCase();
    });
    stylesObject[camelCaseProperty] = value;
  });
  return stylesObject;
};
export var HighlighterWithRichtextHOC = function HighlighterWithRichtextHOC(_ref) {
  var searchWords = _ref.searchWords,
    richText = _ref.richText;
  // Function to parse HTML content and separate text nodes
  var parseHTML = function parseHTML(html) {
    var div = document.createElement('div');
    div.innerHTML = html;
    var nodes = [];
    var _walk = function walk(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        return {
          type: 'text',
          content: node.nodeValue
        };
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        var children = Array.from(node.childNodes).map(_walk);
        return {
          type: 'element',
          tag: node.tagName.toLowerCase(),
          attributes: Array.from(node.attributes).reduce(function (acc, attr) {
            if (attr.name === 'style') {
              acc[attr.name] = transformInlineStyles(attr.value);
            } else {
              acc[attr.name] = attr.value;
            }
            return acc;
          }, {}),
          children: children
        };
      }
      return null;
    };
    div.childNodes.forEach(function (child) {
      return nodes.push(_walk(child));
    });
    return nodes;
  };

  // Recursive function to render nodes with highlighted text
  var _renderNodes = function renderNodes(nodes) {
    return nodes.map(function (node, index) {
      if (node.type === 'text') {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: index
        }, highlightText(node.content, searchWords));
      } else if (node.type === 'element') {
        var Tag = node.tag;
        var selfClosingTags = ['br', 'img', 'input', 'hr', 'meta', 'link'];
        if (selfClosingTags.includes(node.tag)) {
          return /*#__PURE__*/React.createElement(Tag, null);
        } else {
          return /*#__PURE__*/React.createElement(Tag, _extends({
            key: index
          }, node.attributes), _renderNodes(node.children));
        }
      }
      return null;
    });
  };
  var nodes = parseHTML(richText);
  return /*#__PURE__*/React.createElement("div", null, _renderNodes(nodes));
};
export var commonStyles = "cvxmmrs";